/**
 * Catalogo delle definizioni di classe DWR.
 *
 * Ogni classe è definita in un file separato (es. `ladro.ts`) e ri-esportata
 * qui. I file di classe sono **dati**, non logica — niente componenti React,
 * niente funzioni stateful. Solo oggetti che descrivono la classe secondo
 * `ClassDefinitionSchema` in `src/schemas/classDefinition.ts`.
 *
 * **NB**: per gli ID delle classi (`'ladro'`, `'mago'`, …) usare
 * `ClassIdSchema` da `src/schemas/classId.ts` (12 valori canonici DWR), non
 * `keyof typeof dwrClassesById`.
 */

import type { ClassDefinition } from '../../schemas/classDefinition';
import type { ClassId } from '../../schemas/classId';
import { barbaroClassDefinition } from './barbaro';
import { bardoClassDefinition } from './bardo';
import { chiericoClassDefinition } from './chierico';
import { druidoClassDefinition } from './druido';
import { guerrieroClassDefinition } from './guerriero';
import { ladroClassDefinition } from './ladro';
import { magoClassDefinition } from './mago';
import { monacoClassDefinition } from './monaco';
import { paladinoClassDefinition } from './paladino';
import { rangerClassDefinition } from './ranger';
import { sciamanoClassDefinition } from './sciamano';
import { warlockClassDefinition } from './warlock';

export {
  barbaroClassDefinition,
  bardoClassDefinition,
  chiericoClassDefinition,
  druidoClassDefinition,
  guerrieroClassDefinition,
  ladroClassDefinition,
  magoClassDefinition,
  monacoClassDefinition,
  paladinoClassDefinition,
  rangerClassDefinition,
  sciamanoClassDefinition,
  warlockClassDefinition,
};

/**
 * Tutte le ClassDefinition trascritte — **12/12, Fase C COMPLETATA**.
 *
 * Ordinate alfabeticamente per `id`. Coerente con `dwrClassesById`.
 */
export const dwrClasses: readonly ClassDefinition[] = [
  barbaroClassDefinition,
  bardoClassDefinition,
  chiericoClassDefinition,
  druidoClassDefinition,
  guerrieroClassDefinition,
  ladroClassDefinition,
  magoClassDefinition,
  monacoClassDefinition,
  paladinoClassDefinition,
  rangerClassDefinition,
  sciamanoClassDefinition,
  warlockClassDefinition,
];

/**
 * Lookup per ID delle 12 classi trascritte (Fase C COMPLETATA).
 *
 * Il tipo resta `Partial<Record<ClassId, ClassDefinition>>` per coerenza con il
 * pattern precedente: i consumer che usano `dwrClassesById[classId]` ottengono
 * `ClassDefinition | undefined` e quindi gestiscono già il caso assente. Un
 * upgrade a `Record<ClassId, ClassDefinition>` strict resta possibile in
 * Fase D (rivedere quando il builder consuma direttamente il catalogo).
 */
export const dwrClassesById: Partial<Record<ClassId, ClassDefinition>> = {
  barbaro: barbaroClassDefinition,
  bardo: bardoClassDefinition,
  chierico: chiericoClassDefinition,
  druido: druidoClassDefinition,
  guerriero: guerrieroClassDefinition,
  ladro: ladroClassDefinition,
  mago: magoClassDefinition,
  monaco: monacoClassDefinition,
  paladino: paladinoClassDefinition,
  ranger: rangerClassDefinition,
  sciamano: sciamanoClassDefinition,
  warlock: warlockClassDefinition,
};
